import API_URLS from '@mgCommon/constants/api-urls';
import axiosRestInstance from '@mgCommon/http/axios-rest-client';
import { getCbBaseURL, getCbVarible, prepareUrl } from '@mgCommon/utils/utils';
import { AxiosResponse } from 'axios';

type ValidateDeTableArgs = {
  fuel2token?: string | null;
  deName?: string | null;
};

type GetValidationColumnsArgs = {
  fuel2token?: string | null;
  key?: string | null;
  entry?: string | null;
};

type GetRealParamValuesArgs = {
  fuel2token?: string | null;
  key?: string | null;
  propertyName?: string | null;
  entry?: string | null;
};

function restClientInstance() {
  const baseURL = getCbBaseURL();
  return axiosRestInstance({ baseURL });
}

function config(queryParams: Record<string, unknown> = {}) {
  const token = getCbVarible();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    params: queryParams,
    data: {},
  };
}

class McValidationService {
  validateDeTable({
    fuel2token = '',
    deName = '',
  }: ValidateDeTableArgs): Promise<AxiosResponse<{ customerKey: string; name: string }>> {
    const url = prepareUrl(
      API_URLS.VALIDATE_DE_TABLE,
      { variable: '{fuel2token}', value: fuel2token },
      { variable: '{deName}', value: deName }
    );
    return restClientInstance().get(url, config());
  }

  getValidationColumns({
    fuel2token = '',
    key = '',
    entry = '',
  }: GetValidationColumnsArgs): Promise<AxiosResponse<{ result: string[] }>> {
    const url = prepareUrl(
      API_URLS.GET_VALIDATION_COLUMNS,
      { variable: '{fuel2token}', value: fuel2token },
      { variable: '{key}', value: key },
      { variable: '{entry}', value: entry }
    );
    return restClientInstance().get(url, config());
  }

  getRealParamValues({
    fuel2token = '',
    key = '',
    propertyName = '',
    entry = '',
  }: GetRealParamValuesArgs): Promise<AxiosResponse<{ result: string[] }>> {
    const url = prepareUrl(
      API_URLS.GET_REAL_PARAM_VALUES,
      { variable: '{fuel2token}', value: fuel2token },
      { variable: '{key}', value: key },
      { variable: '{propertyName}', value: propertyName },
      { variable: '{entry}', value: entry }
    );
    return restClientInstance().get(url, config());
  }
}

export default new McValidationService();
